var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "current",
    width: "800px",
    height: "800px",
    viewBox: "-2 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m19.638 8.945c0-.263-.093-.504-.249-.692l.001.002-.004-.006c-.02-.024-.041-.047-.063-.069l-.009-.009c-.009-.009-.019-.02-.028-.029l-7.823-7.821c-.022-.022-.046-.044-.07-.063l-.022-.02c-.018-.014-.036-.027-.054-.04l-.027-.018-.058-.036-.024-.014c-.027-.015-.054-.027-.081-.039l-.033-.013-.057-.021-.037-.012-.067-.017-.026-.006c-.031-.006-.063-.011-.094-.015h-.027c-.027 0-.053 0-.08 0h-9.613c-.6 0-1.087.485-1.091 1.084v21.818c0 .603.489 1.091 1.091 1.091h17.454c.603 0 1.091-.489 1.091-1.091v-13.935c0-.009.001-.019.001-.029zm-7.857-5.225 4.13 4.135h-4.13zm-9.599 18.098v-19.637h7.42v6.767c0 .603.489 1.091 1.091 1.091h6.767v11.779z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/FileIcon.9e8b53effbca3c9bdedf938444374b85.svg";
export { ForwardRef as ReactComponent };